import { NgModule } from "@angular/core";
import { S25ConflictsComponent } from "./s25.conflicts.component";
import { CommonModule } from "@angular/common";
import { S25ItemModule } from "../s25-item/s25.item.module";
import { S25PipesModule } from "../../pipes/s25.pipes.module";
import { S25SimpleCollapseModule } from "../s25-simple-collapse/s25.simple.collapse.module";
import { S25LoadingInlineModule } from "../s25-loading/s25.loading.inline.module";
import { S25IconComponent } from "../s25-icon/s25.icon.component";

@NgModule({
    imports: [
        CommonModule,
        S25ItemModule,
        S25PipesModule,
        S25SimpleCollapseModule,
        S25LoadingInlineModule,
        S25IconComponent,
    ],
    exports: [S25ConflictsComponent],
    providers: [S25ConflictsComponent],
    declarations: [S25ConflictsComponent],
})
export class S25ConflictsModule {}
